'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from 'AdsUI/lib/Actions';
export default ((state = ImmutableMap(), action) => {
  const payload = action.payload || {};
  const {
    campaignId,
    funnels
  } = payload;

  switch (action.type) {
    case ActionTypes.FB_BREAKDOWN_FUNNELS_FETCH_SUCCEEDED:
      return state.set(campaignId, funnels);

    default:
      return state;
  }
});